function CruHome() {
  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4, color: '#2C5F2E' }}>Cru</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Bike-friendly cafés, crowd-sourced.</p>

      <p>
        Cru is a crowd-sourced map for finding bike-friendly cafés. Explore a map of spots near
        you, filter by outdoor seating and bike rack availability, and submit new cafés for
        others to discover.
      </p>

      <h2>What it does</h2>
      <ul>
        <li><strong>Map &amp; explore</strong> — browse cafés on a map or as a searchable list, sorted by distance from you.</li>
        <li><strong>Filters</strong> — narrow results by outdoor seating and bike rack availability.</li>
        <li><strong>Submit a café</strong> — drop a pin, add details and photos, and submit a new spot for review.</li>
      </ul>

      <p>
        Cru doesn't require an account or sign-in. Submitted cafés are reviewed before they
        appear publicly on the map.
      </p>

      <h2>Legal</h2>
      <ul>
        <li><a href="/cru/privacy">Privacy Policy</a></li>
        <li><a href="/cru/tos">Terms of Service</a></li>
      </ul>

      <h2>Contact</h2>
      <p>
        Questions about the app:&nbsp;
        <a href="mailto:dennis.hvel@gmail.com">dennis.hvel@gmail.com</a>
      </p>
    </div>
  );
}

export default CruHome;
